module.exports = __webpack_public_path__ + "media/images/lp/1/achievement5-sp-8794a62c84a052dd2cb996765b9aee67.png";